import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import HomePage from "./HomePage";
import { AboutPage } from "./About";
import { TeamPage } from "./Team";
import CaseStudiesPage from "./CaseStudies";
import CaseStudyPost from "./CaseStudyPost";
import DocsPage from "./Docs";
import ContactPage from "./Contact";
import Header from "./Header";
import Footer from "./Footer";

function NotFound() {
  return (
    <div className="container">
      <h2>404 - Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <HomePage />
              <Footer />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <Header />
              <AboutPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/team"
          element={
            <>
              <Header />
              <TeamPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/case-studies"
          element={
            <>
              <Header />
              <CaseStudiesPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/case-studies/:slug"
          element={
            <>
              <Header />
              <CaseStudyPost />
              <Footer />
            </>
          }
        />
        <Route
          path="/docs"
          element={
            <>
              <Header />
              <DocsPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Header />
              <ContactPage />
              <Footer />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Header />
              <NotFound />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}
